/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: request
 */

import { RESPONSE_STATUS } from '@/constants';
import { loginAtom, store } from '@/utils/atoms';

export const fetcher = async (url: string, options?: Object) => {
  const response = await fetch(url, {...options, credentials: 'include'});
  if (!response.ok) {
    throw new Error('Request failed');
  }
  const data = await response.json();
  // 接口处理登录
  if (data.retCode === RESPONSE_STATUS.TOKEN_ERROR) {
    store.set(loginAtom, {visibleLogin: true});
  }
  return data;
};


export const post = async (url: string, data?: object, options?: any) => {
  return await fetcher(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    ...options,
  });

};